import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { MyDatePickerModule } from 'mydatepicker';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ValidateVinSearchComponent } from './validate-vin-search/validate-vin-search.component';
import { ValidateVINComponent } from './validate-vin.component';
import { ValidateVINService } from './validate-vin.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MyDatePickerModule,
    ReactiveFormsModule,
    Trip2ThemeModule,
    AgGridModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  declarations: [ValidateVINComponent, ValidateVinSearchComponent],
  exports: [ValidateVINComponent],
  providers: [
    ValidateVINService
  ]
})
export class ValidateVINModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/validate-vin/validate-vin.module.ts